<template>
  <v-card>
    <v-layout mx-4 pt-4 wrap>
      <v-flex md8>
        <v-text-field
          name="email"
          label="Email"
          id="email"
          v-model="customer.email"
        ></v-text-field>
      </v-flex>
      <v-flex md4>
        <v-text-field
          name="instagram"
          label="Instagram"
          id="instagram"
          v-model="customer.instagram"
        ></v-text-field>
      </v-flex>
      <v-flex md4>
        <v-text-field
          name="mobilePhone1"
          label="Celular 1"
          id="mobilePhone1"
          v-model="customer.mobileNumber1"
        ></v-text-field>
      </v-flex>
      <v-flex md4>
        <v-text-field
          name="mobilePhone2"
          label="Celular 2"
          id="mobilePhone2"
          v-model="customer.mobileNumber2"
        ></v-text-field>
      </v-flex>
      <v-flex md4>
        <v-text-field
          name="phone"
          label="Tel. Fixo"
          id="phone"
          v-model="customer.phoneNumber"
        ></v-text-field>
      </v-flex>
      <v-flex md6>
        <v-checkbox
          value="1"
          label="Aceite de Marketing Digital"
          type="checkbox"
          v-model="customer.acceptsMarketingCommunication"
        ></v-checkbox>
      </v-flex>
    </v-layout>
  </v-card>
</template>
<script>
export default {
  props: ["customer"]
};
</script>
